module.exports = __webpack_public_path__ + "img/销管中心1.fa51d87f.png";